const specialChars = /[!@#$%^&*_+=?/~’;’,<>|\\]/;
const alpha = /[a-zA-Z]/;
const numeric = /[0-9]/;

/**
 * Reusable password validation function
 * @param {Object} form - Ant Design Form instance
 * @returns {Function} - Validator function for password validation
 */
export const validatePassword = (form) => async (_, password) => {
    if (!password) {
        return Promise.reject(new Error('Password is required.'));
    }
    if (password.length < 8) {
        return Promise.reject(new Error('Password must be at least 8 characters long.'));
    }
    if (!specialChars.test(password)) {
        return Promise.reject(new Error('Password must contain at least one special character.'));
    }
    if (!alpha.test(password)) {
        return Promise.reject(new Error('Password must contain at least one letter.'));
    }
    if (!numeric.test(password)) {
        return Promise.reject(new Error('Password must contain at least one number.'));
    }

    // Ensure username and email exist before using them
    const userName = form.getFieldValue('userName') || '';
    const email = form.getFieldValue('email') || '';

    console.log("DEBUG: Username:", userName, "Email:", email);


    // **Reject only if password exactly matches username or email**
    if (userName && (password.toLowerCase() === userName.toLowerCase())) {
        return Promise.reject(new Error('Password must not be exactly the same as your username.'));
    }
    if (email && (password.toLowerCase() === email.toLowerCase())) {
        return Promise.reject(new Error('Password must not be exactly the same as your email.'));
    }

    return Promise.resolve();
};

export const passwordPolicy = (
    <div>
        <p>✅ Must be at least 8 characters long</p>
        <p>✅ Must contain at least one uppercase letter</p>
        <p>✅ Must contain at least one lowercase letter</p>
        <p>✅ Must contain at least one number</p>
        <p>✅ Must contain at least one special character (@, #, $, etc.)</p>
    </div>
);
